import { Component, OnInit } from '@angular/core';

interface AlumniTab {
  id: string;
  label: string;
}

interface AlumniStat {
  label: string;
  value: string;
}

interface GalleryPhoto {
  image: string;
  alt: string;
}

interface GalleryGroup {
  title: string;
  caption: string;
  photos: GalleryPhoto[];
}

@Component({
  selector: 'app-home-page-two',
  templateUrl: './home-page-two.component.html',
  styleUrls: ['./home-page-two.component.scss']
})
export class HomePageTwoComponent implements OnInit {
  selectedTab = 'tab1';

  pageTitle = 'Alumni Relations';
  pageSubtitle =
    'Strengthening lifelong bonds with our graduates through celebrations, engagement, interaction, and institutional pride.';

  admissionNotice =
    'Admissions open for 2026 : B.E (CIVIL), B.E (CSE), B.E (CSE - AI & ML), B.E (CSE - CS), B.E (ECE), B.E (EEE), B.E (MECH), MBA, M.E (CSE), M.E (Embedded System Technologies), M.E (Thermal Engineering).';

  tabs: AlumniTab[] = [
    { id: 'tab1', label: 'About Alumni Relations' },
    { id: 'tab2', label: 'Alumni Pongal 2026' },
    { id: 'tab3', label: 'Alumni Meet 2024' }
    
  ];

  heroStats: AlumniStat[] = [
    { label: 'Engagement', value: 'Events & Reunions' },
    { label: 'Focus', value: 'Alumni Connect' },
    { label: 'Culture', value: 'Tradition & Unity' },
    { label: 'Community', value: 'Students • Staff • Alumni' }
  ];

  aboutParagraphs: string[] = [
    'The Alumni Relations page of Fatima Michael College of Engineering and Technology celebrates the enduring connection between the institution and its graduates.',
    'Through reunions, cultural celebrations, interaction sessions, and institutional events, alumni continue to remain an important part of the academic and social fabric of the college.',
    'These programmes create a strong sense of belonging, inspire current students through alumni experiences, and reinforce lifelong bonds with the institution.'
  ];

  aboutHighlights: string[] = [
    'Promotes meaningful interaction between alumni, students, faculty, and management.',
    'Strengthens the alumni-institution relationship through cultural and formal engagement events.',
    'Creates opportunities for networking, mentorship, guidance, and shared institutional pride.',
    'Celebrates alumni achievements and encourages continued contribution to the college community.'
  ];

  alumniPongal2026Paragraphs: string[] = [
    'Alumni Pongal 2026 was joyfully celebrated at Fatima Michael College of Engineering and Technology, bringing together alumni, students, faculty, and staff in a spirit of tradition and togetherness.',
    'The event highlighted the rich cultural heritage of Pongal with traditional decorations, including kolams and festive setups. Alumni actively participated in the celebrations, reconnecting with their alma mater and sharing their experiences with current students.',
    'Key activities included Pongal preparation, cultural performances, fun games, and interactive sessions that strengthened the bond between past and present members of the institution. The celebration fostered a sense of pride, nostalgia, and unity among attendees.',
    'Overall, Alumni Pongal 2026 was a vibrant and memorable event that successfully blended cultural tradition with alumni engagement, reinforcing lifelong connections with the college.'
  ];

  alumniMeet2024Paragraphs: string[] = [
    'The Alumni Meet 2024 at Fatima Michael College of Engineering and Technology was organized with the objective of reconnecting former students with their alma mater and strengthening alumni–institution relationships.',
    'The event brought together graduates from various batches, faculty members, and current students, creating a platform for interaction, networking, and sharing experiences. Alumni enthusiastically participated and revisited their college memories, fostering a sense of nostalgia and belonging.',
    'The programme commenced with a welcome address by the faculty or alumni coordinators, followed by speeches from distinguished alumni who shared their professional journeys, achievements, and industry insights. These sessions provided valuable guidance to current students regarding career opportunities, higher education, and skill development.',
    'Interactive sessions and informal discussions were key highlights of the meet, allowing alumni to exchange ideas with students and faculty. Cultural activities and entertainment programs added vibrancy to the event and encouraged active participation.',
    'The meet concluded with a vote of thanks, appreciating the presence and contributions of alumni. Overall, the Alumni Meet 2024 was a successful event that strengthened bonds, inspired students, and promoted continued engagement between alumni and the institution.'
  ];

  alumniPongal2026Groups: GalleryGroup[] = [
    {
      title: 'Group Photos with Alumni and Staff',
      caption: 'Group Photos for our Alumni students and staff members during Alumni Pongal celebration @ 13.01.2026',
      photos: [
        { image: 'assets/img/alumni/pongal-2026-group-staff-1.jpeg', alt: 'Alumni Pongal 2026 group photo with staff 1' },
        { image: 'assets/img/alumni/pongal-2026-group-staff-2.jpeg', alt: 'Alumni Pongal 2026 group photo with staff 2' }
        
      ]
    },
    {
      title: 'Group Photos with Vice Chairman',
      caption: 'Group Photos for our Alumni students, staff members and our Vice Chairman during Alumni Pongal celebration @ 13.01.2026',
      photos: [
        { image: 'assets/img/alumni/pongal-2026-vice-chairman-1.jpeg', alt: 'Alumni Pongal 2026 group photo with Vice Chairman 1' },
        { image: 'assets/img/alumni/pongal-2026-vice-chairman-2.jpeg', alt: 'Alumni Pongal 2026 group photo with Vice Chairman 2' },
        { image: 'assets/img/alumni/pongal-2026-vice-chairman-3.jpeg', alt: 'Alumni Pongal 2026 group photo with Vice Chairman 3' }
  
      ]
    },
    {
      title: 'Traditional Games',
      caption: 'Various traditional games were conducted for our Alumni students @ 13.01.2026',
      photos: [
        { image: 'assets/img/alumni/pongal-2026-games-1.jpeg', alt: 'Alumni Pongal 2026 traditional games 1' },
        { image: 'assets/img/alumni/pongal-2026-games-2.jpeg', alt: 'Alumni Pongal 2026 traditional games 2' }

      ]
    },
    {
      title: 'Alumni Meeting in Auditorium',
      caption: 'Alumni meeting was conducted in Vedhamuthu Auditorium @ 13.01.2026',
      photos: [
        { image: 'assets/img/alumni/pongal-2026-auditorium-1.jpeg', alt: 'Alumni Pongal 2026 auditorium meeting 1' },
        { image: 'assets/img/alumni/pongal-2026-auditorium-2.jpeg', alt: 'Alumni Pongal 2026 auditorium meeting 2' },
         { image: 'assets/img/alumni/pongal-2026-auditorium-3.jpeg', alt: 'Alumni Pongal 2026 auditorium meeting 3' },
        { image: 'assets/img/alumni/pongal-2026-auditorium-4.jpeg', alt: 'Alumni Pongal 2026 auditorium meeting 4' }

     
      ]
    },
    {
      title: 'Lunch Arrangement',
      caption: 'Management arranged lunch for our Alumni students.',
      photos: [
        { image: 'assets/img/alumni/pongal-2026-lunch-1.jpeg', alt: 'Alumni Pongal 2026 lunch arrangement 1' },
        { image: 'assets/img/alumni/pongal-2026-lunch-2.jpeg', alt: 'Alumni Pongal 2026 lunch arrangement 2' }
      ]
    }
  ];

  alumniMeet2024Groups: GalleryGroup[] = [
    {
      title: 'Group Photos with Management, Principal and Staff',
      caption: 'Group Photos for our Alumni students, Management, Principal and Staff members @ 06.04.2024',
      photos: [
        { image: 'assets/img/alumni/meet-2024-group-1.jpeg', alt: 'Alumni Meet 2024 group photo 1' },
        { image: 'assets/img/alumni/meet-2024-group-2.jpeg', alt: 'Alumni Meet 2024 group photo 2' },
        { image: 'assets/img/alumni/meet-2024-group-3.jpeg', alt: 'Alumni Meet 2024 group photo 3' },
        { image: 'assets/img/alumni/meet-2024-group-4.jpeg', alt: 'Alumni Meet 2024 group photo 4' }
      ]
    },
    {
      title: 'Games for Alumni Students',
      caption: 'Various games were conducted for our Alumni students @ 06.04.2024',
      photos: [
        { image: 'assets/img/alumni/ag1.jpeg', alt: 'Alumni Meet 2024 games 1' },
        { image: 'assets/img/alumni/ag2.jpeg', alt: 'Alumni Meet 2024 games 2' },
        { image: 'assets/img/alumni/ag3.jpeg', alt: 'Alumni Meet 2024 games 3' },
        { image: 'assets/img/alumni/ag4.jpeg', alt: 'Alumni Meet 2024 games 4' }
      ]
    },
    {
      title: 'Cultural Event',
      caption: 'Cultural Event was conducted for our Alumni students @ 06.04.2024',
      photos: [
        { image: 'assets/img/alumni/meet-2024-cultural-1.jpeg', alt: 'Alumni Meet 2024 cultural event 1' },
        { image: 'assets/img/alumni/meet-2024-cultural-2.jpeg', alt: 'Alumni Meet 2024 cultural event 2' },
        { image: 'assets/img/alumni/meet-2024-cultural-3.jpeg', alt: 'Alumni Meet 2024 cultural event 3' },
        { image: 'assets/img/alumni/meet-2024-cultural-4.jpeg', alt: 'Alumni Meet 2024 cultural event 4' }
      ]
    },
    {
      title: 'Alumni Interaction with Current Students',
      caption: 'Alumni students interacted with our current students @ 06.04.2024',
      photos: [
        { image: 'assets/img/alumni/meet-2024-interaction-1.jpeg', alt: 'Alumni Meet 2024 student interaction 1' },
        { image: 'assets/img/alumni/meet-2024-interaction-2.jpeg', alt: 'Alumni Meet 2024 student interaction 2' },
        { image: 'assets/img/alumni/meet-2024-interaction-3.jpeg', alt: 'Alumni Meet 2024 student interaction 3' },
        { image: 'assets/img/alumni/meet-2024-interaction-4.jpeg', alt: 'Alumni Meet 2024 student interaction 4' }
      ]
    },
    {
      title: 'Gift Distribution',
      caption: 'Management gave gifts to our Alumni students @ 06.04.2024',
      photos: [
        
        { image: 'assets/img/alumni/meet-2024-gifts-2.jpeg', alt: 'Alumni Meet 2024 gift distribution 2' },
        { image: 'assets/img/alumni/meet-2024-gifts-3.jpeg', alt: 'Alumni Meet 2024 gift distribution 3' },
        
      ]
    },
    {
      title: 'Address by Management and Principal',
      caption: 'Management and Principal addressed our Alumni students @ 06.04.2024',
      photos: [
        { image: 'assets/img/alumni/meet-2024-address-2.jpeg', alt: 'Alumni Meet 2024 address by management 1' },
        { image: 'assets/img/alumni/meet-2024-address-1.jpeg', alt: 'Alumni Meet 2024 address by management 2' }
        
      ]
    }
  ];

  photoNamingGuide: string[] = [
    'assets/img/alumni/pongal-2026-group-staff-1.jpg',
    'assets/img/alumni/pongal-2026-group-staff-2.jpg',
    'assets/img/alumni/pongal-2026-group-staff-3.jpg',
    'assets/img/alumni/pongal-2026-group-staff-4.jpg',
    'assets/img/alumni/pongal-2026-vice-chairman-1.jpg',
    'assets/img/alumni/pongal-2026-vice-chairman-2.jpg',
    'assets/img/alumni/pongal-2026-vice-chairman-3.jpg',
    'assets/img/alumni/pongal-2026-vice-chairman-4.jpg',
    'assets/img/alumni/pongal-2026-games-1.jpg',
    'assets/img/alumni/pongal-2026-games-2.jpg',
    'assets/img/alumni/pongal-2026-games-3.jpg',
    'assets/img/alumni/pongal-2026-games-4.jpg',
    'assets/img/alumni/pongal-2026-auditorium-1.jpg',
    'assets/img/alumni/pongal-2026-auditorium-2.jpg',
    'assets/img/alumni/pongal-2026-auditorium-3.jpg',
    'assets/img/alumni/pongal-2026-auditorium-4.jpg',
    'assets/img/alumni/pongal-2026-lunch-1.jpg',
    'assets/img/alumni/pongal-2026-lunch-2.jpg',
    'assets/img/alumni/meet-2024-group-1.jpg',
    'assets/img/alumni/meet-2024-group-2.jpg',
    'assets/img/alumni/meet-2024-group-3.jpg',
    'assets/img/alumni/meet-2024-group-4.jpg',
    'assets/img/alumni/meet-2024-games-1.jpg',
    'assets/img/alumni/meet-2024-games-2.jpg',
    'assets/img/alumni/meet-2024-games-3.jpg',
    'assets/img/alumni/meet-2024-games-4.jpg',
    'assets/img/alumni/meet-2024-cultural-1.jpg',
    'assets/img/alumni/meet-2024-cultural-2.jpg',
    'assets/img/alumni/meet-2024-cultural-3.jpg',
    'assets/img/alumni/meet-2024-cultural-4.jpg',
    'assets/img/alumni/meet-2024-interaction-1.jpg',
    'assets/img/alumni/meet-2024-interaction-2.jpg',
    'assets/img/alumni/meet-2024-interaction-3.jpg',
    'assets/img/alumni/meet-2024-interaction-4.jpg',
    'assets/img/alumni/meet-2024-gifts-1.jpg',
    'assets/img/alumni/meet-2024-gifts-2.jpg',
    'assets/img/alumni/meet-2024-gifts-3.jpg',
    'assets/img/alumni/meet-2024-gifts-4.jpg',
    'assets/img/alumni/meet-2024-address-1.jpg',
    'assets/img/alumni/meet-2024-address-2.jpg',
    'assets/img/alumni/meet-2024-address-3.jpg'
  ];

  constructor() {}

  get activeTabLabel(): string {
    return this.tabs.find((tab) => tab.id === this.selectedTab)?.label || 'Alumni Relations';
  }

  selectTab(tabId: string): void {
    this.selectedTab = tabId;
  }

  ngOnInit(): void {}
}